import { render, staticRenderFns } from "./BasicListGroup.vue?vue&type=template&id=ca755d90"
import script from "./BasicListGroup.vue?vue&type=script&lang=js"
export * from "./BasicListGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports